module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ArticleBox":{"linkReadMore":"Celý článek"}}}')
  delete Component.options._Ctor
}
